<template>
  <div
    class="container"
    :class="{ smaller_gap: isSmallerGap, no_gap: isNoGap }"
  >
    <div class="container_header">
      <slot name="header" />
    </div>
    <div class="container_body">
      <slot name="body" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Container",
  props: {
    isSmallerGap: {
      type: Boolean,
      default: false,
    },
    isNoGap: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  border-radius: 10px;
  border: 1px solid #1a1a1a;
  background: #111;
  padding: 24px 32px;
  gap: 24px;

  &_header {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }

  &_body {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    // border-top: 1px solid #1a1a1a;
  }
}

.smaller_gap {
  gap: 16px;
}

.no_gap {
  transition: 0.3s ease;
  gap: 0;
}

.transaction-detail-instant-link {
  cursor: pointer;
}
</style>
